const translations = {
    calibrationType: 'Calibration type',
    calibrationTypeIsRequired: 'Calibration type is required'
};

export default translations;
